import { Component, OnInit } from "@angular/core";
import { MatBottomSheet, MatBottomSheetRef } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material";
import { SupportService } from "src/app/services/freshdeskApi/support.service";
import { DialogErrorComponent } from "src/app/shared/dialog/dialog-error/dialog-error.component";
import { DialogModelError } from "src/app/shared/dialog/dialog-error/model";
import { DialogProgressComponent } from "src/app/shared/dialog/dialog-progress/dialog-progress.component";
import { DialogModelProgress } from "src/app/shared/dialog/dialog-progress/model";
import { DialogSuccessComponent } from "src/app/shared/dialog/dialog-success/dialog-success.component";
import { DialogModelSuccess } from "src/app/shared/dialog/dialog-success/model";


@Component({
  selector: "app-support",
  templateUrl: "./support.component.html",
  styleUrls: ["./support.component.scss"]
})
export class SupportComponent implements OnInit {
  _mFormGroup: FormGroup;
  mDialogRef: MatDialogRef<DialogProgressComponent, any>;
  _mInProgress = false;
  randomValue = Math.floor(Math.random() * 1000);
  uniqueId = "Technical Support_" + this.randomValue;
  supportDataObject = {
    custom_fields: {
      cf_service_issue: false,
      cf_plans_and_pricing: false,
      cf_billing_issue: false,
      cf_technical_support: false,
      cf_partner_account_issue: false
    },
    description: "",
    unique_external_id: ""
  };

  constructor(
    private _bottomSheetRef: MatBottomSheetRef<SupportComponent>,
    private supportService: SupportService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
  ) {
    this._mFormGroup = this.formBuilder.group({
      cf_service_issue: [false],
      cf_plans_and_pricing: [false],
      cf_billing_issue: [false],
      cf_technical_support: [false],
      cf_partner_account_issue: [false],
      description_text: ["", Validators.required]
    });
  }

  ngOnInit() {}

  _cancel() {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }

  _onSubmit() {
    this._cancel();
    this.openProgress();
    this.addTicket();
  }

  addTicket() {
    this.supportDataObject.custom_fields.cf_service_issue = this._mFormGroup.value.cf_service_issue;
    this.supportDataObject.custom_fields.cf_plans_and_pricing = this._mFormGroup.value.cf_plans_and_pricing;
    this.supportDataObject.custom_fields.cf_billing_issue = this._mFormGroup.value.cf_billing_issue;
    this.supportDataObject.custom_fields.cf_technical_support = this._mFormGroup.value.cf_technical_support;
    this.supportDataObject.custom_fields.cf_partner_account_issue = this._mFormGroup.value.cf_partner_account_issue;
    this.supportDataObject.description = this._mFormGroup.value.description_text;
    this.supportDataObject.unique_external_id = this.uniqueId;
    this.supportService
      .createTicket(this.supportDataObject)
      .subscribe(response => {
        this.closeProgress();
        this.openSuccess("Successfully Reported");
      }, error => {
         this.closeProgress();
         this.openError("Something Went Wrong Please Try Again..");
      });
  }

  /***************************************************************************************************************
   * 											Progress
   */

  openProgress() {
    this._mInProgress = true;
    let alert: DialogModelProgress = new DialogModelProgress(
      "Sending...",
      "",
      null,
      null
    );

    // setTimeout(() => {
    //   this.openSuccess("ressssssssss");
    // }, 2000);

    this.mDialogRef = this.dialog.open(DialogProgressComponent, {
      data: alert,
      disableClose: true
    });
  }

  closeProgress() {
    this._mInProgress = false;
    if (this.mDialogRef) this.mDialogRef.close();
  }

  openSuccess(response: string) {
    this._mInProgress = true;
    let alert: DialogModelSuccess = new DialogModelSuccess(
      response,
      "",
      null,
      null
    );

    this.mDialogRef = this.dialog.open(DialogSuccessComponent, {
      data: alert,
      disableClose: false
    });
  }

  closeSuccess() {
    this._mInProgress = false;
    if (this.mDialogRef) this.mDialogRef.close();
  }

  openError(response: string) {
    // "Registration Successfull Please Check Your Mail";
    this._mInProgress = true;
    let alert: DialogModelError = new DialogModelError(
      response,
      "",
      null,
      null
    );

    this.mDialogRef = this.dialog.open(DialogErrorComponent, {
      data: alert,
      disableClose: false
    });
  }

  closeError() {
    this._mInProgress = false;
    if (this.mDialogRef) this.mDialogRef.close();
  }
}
